<template>
	<div class="g-display-list-filtering-container u-flex g-layout--align-center g-layout--wrap">

		<div v-if="!hidePlantIcons" class="g-display-list-filtering-plant-icons u-width-12 u-width-5--l">
			<div class="g-display-list-filtering-plant-icons__item">
				<span class="g-display-list-filtering-plant-icons__item-icon u-icon-seeds-circle" aria-hidden="true"></span>
				<span class="g-display-list-filtering-plant-icons__item-label">Seeds</span>
			</div>

			<div class="g-display-list-filtering-plant-icons__item">
				<span class="g-display-list-filtering-plant-icons__item-icon u-icon-root-plants-circle" aria-hidden="true"></span>
				<span class="g-display-list-filtering-plant-icons__item-label">Bare Root Plants</span>
			</div>

			<div class="g-display-list-filtering-plant-icons__item">
				<span class="g-display-list-filtering-plant-icons__item-icon u-icon-potted-plants-circle" aria-hidden="true"></span>
				<span class="g-display-list-filtering-plant-icons__item-label">Potted Plants</span>
			</div>
		</div>

		<div :class="['g-display-list-filtering-items-container', 'u-width-12', {'u-width-7--l': !hidePlantIcons}]">
			<div class="g-display-list-filtering">
				<per-page :pagination="pagination" />

				<div v-if="facets?.length" class="g-display-list-filtering__item g-display-list-filter-button">
					<button @click="showFacetsDrawer()" type="button" class="g-display-list-filter-button__trigger g-button--no-styling" aria-label="Open Filters" aria-haspopup="dialog">
						<span class="g-display-list-filter-button__icon u-icon-filter" aria-hidden="true" focusable="false"></span>
						Filter
					</button>
				</div>

				<div v-if="pagination && pagination.totalResults > 0" class="g-display-list-filtering__item g-display-list-filtering__product-count g-product-list__product-count">
					{{ pagination.totalResults }} {{ pagination.totalResults > 1 ? 'Items' : 'Item' }}
				</div>

				<sort-by :sorting="sorting" />
			</div>
		</div>
	</div>
</template>

<script>

	import PerPage from './PerPage';
	import SortBy from './SortBy';
	import Pagination from './Pagination';
	import ProductList from './ProductList';
	import MicroModal from 'micromodal';
	import {hidePlantIcons} from '../../common-functions';

	export default {
		data() {
			return {
				showSort: false
			}
		},
		props: {
			facets: {
				default() {
					return [];
				}
			},
			filterSummary: {
				default() {
					return {};
				}
			},
			merchandising: {
				default() {
					return {};
				}
			},
			pagination: {
				default() {
					return {};
				}
			},
			results: {
				default() {
					return {};
				}
			},
			sorting: {
				default() {
					return {};
				}
			}
		},
		computed: {
			hidePlantIcons () {
				return hidePlantIcons();
			}
		},
		methods: {
			showFacetsDrawer () {
				MicroModal.show('js-facets');
			}
		},
		components: {
			'per-page': PerPage,
			'sort-by': SortBy,
			'pagination': Pagination,
			'product-list': ProductList
		}
	}

</script>
